export default "__VITE_ASSET__Bblr4yAZ__"